export function getFromStorage(key: string): string | null {
  try {
    return window.sessionStorage.getItem(key);
  } catch (e) {
    console.error(`cannot get from session storage for key ${key}:`, e);
    return null;
  }
}
export function getAccessToken(): string | null {
  try {
    const auth = getFromStorage("authenticate");
    return auth ? JSON.parse(auth).accessToken : null;
  } catch (e) {
    console.error(`cannot get from session storage for accessToken:`, e);
    return null;
  }
}

export function setToStorage(key, value) {
  const hasVal = typeof value === "object" && value !== null;
  const newVal = hasVal ? JSON.stringify(value) : value;
  try {
    window.sessionStorage.setItem(key, newVal);
  } catch (e) {
    console.error(`cannot set session storage for key: ${key}:`, e);
  }
}

export function removeFromStorage(item) {
  try {
    window.sessionStorage.removeItem(item);
  } catch (e) {
    console.error(`cannot remove from session storage for key ${item}:`, e);
  }
}
